// extracted by mini-css-extract-plugin
export var container = "style-module--container--7323c";
export var heading = "style-module--heading--797ff";